import {baseInstance} from './baseInstance';

export const authApi = {
        authenticate: (data) => baseInstance.post(`/auth/authenticate`, data),    
        getProfile: () => baseInstance.get(`/users/me`),    
}